import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { MenuItem, MessageService } from 'primeng/api';
import { AdamsDocModel } from 'src/app/models/adams-doc-model';
import { LoaderService } from 'src/app/services/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doc-properties-view',
  templateUrl: './doc-properties-view.component.html',
  styleUrls: ['./doc-properties-view.component.css']
})
export class DocPropertiesViewComponent implements OnInit {

  item: AdamsDocModel = {};
  showCopyMsg = false;
  loading = false;
  shareDocPropItems: MenuItem[] = [];
  shareDocItems: MenuItem[] = [];

  constructor(private actRouter: ActivatedRoute, private router: Router,
    private clipboardApi: ClipboardService, private msgService: MessageService,
    private loaderSvc: LoaderService, private titleSvc: Title) {

    this.titleSvc.setTitle(environment.site_name + ' - Properties');
  }

  ngOnInit(): void {
    this.subscribeLoader();
    this.actRouter.data.subscribe((d: any) => {
      this.item = d.props;
    });

    this.shareDocPropItems = [
      {
        label: 'Copy Properties Link',
        icon: 'fa-regular fa-copy',
        command: () => this.copyPropertiesLink(),
      },
      // {
      //   label: 'Email Properties Link',
      //   icon: 'fa-regular fa-envelope',
      //   url: 'mailto:user@nrc.gov?subject=ADAMS%20PUBLIC%20SEARCH%20-%20Document%20Properties%20Link&body=Document%20Properties%20Link',
      // },

    ];
    this.shareDocItems = [
      {
        label: 'Copy Link',
        icon: 'fa-regular fa-copy',
        command: () => this.copyClipboard(),
      },
      {
        label: 'Download',
        icon: 'fa-solid fa-file-arrow-down',
        url: this.item.Url
      },
      // {
      //   label: 'Email Link',
      //   icon: 'fa-regular fa-envelope',
      //   url: 'mailto:user@nrc.gov?subject=ADAMS%20PUBLIC%20SEARCH%20-%20Document%20Link&body=Document%20Link',
      // },
    ];
  }

  subscribeLoader() {
    this.loaderSvc.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }

  copyClipboard() {
    if (this.item.Url) {
      this.clipboardApi.copyFromContent(this.item.Url);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Link Copied', detail: 'Document Link Copied to Clipboard' });
    }
  }

  copyPropertiesLink() {
    if (this.item.IdT) {
      let host = window.location.origin;
      let rUrl = this.router.createUrlTree(['/props/', this.item.IdT]);
      let link = host + rUrl;
      this.clipboardApi.copyFromContent(link);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Document Properties Copied', detail: 'Document Properties Link Copied to Clipboard' });
    }
  }
}
